import React from 'react';
import {NodeInterface} from "./interfaces";
import styled from "styled-components/macro";
import colors from "../../styles/variables/colors";

const BubbleWrap = styled.div`
  display: block;
  margin-bottom: 5px;
  height: auto;
`;

const NodeBubble = styled.a`
  font-family: "Helvetica Now Text W01 Medium";
  color: ${colors.slate.base};
  padding: 10px 15px 11px;
  display: inline-block;
  background-color: ${colors.slate["5"]};
  width: auto;
  height: auto;
  font-weight: 500;
  border-radius: 30px;
  font-size: 16px;
`;

interface NodeProps {
  node: NodeInterface
}

type ResultComponent = (props: NodeProps) => JSX.Element;

const Result: ResultComponent = ({node}) => {
  return (
    <BubbleWrap>
      <NodeBubble href={node.link} title={node.title} target={'_blank'} rel="noreferrer">{node.title}</NodeBubble>
    </BubbleWrap>
  )
}
export default Result;
